
import { DatabaseService } from '@/services/DatabaseService'

export const state = {
  latest: {},
}

export const mutations = {
  setLatest(state, latest) {
    state.database.latest = latest
  },
}

export const actions = {
  getDatabase({ commit, rootState, getters }) {
    const clientid = rootState.authentication.userProfile.attributes
    if (clientid) {
      DatabaseService.get(rootState.context.currentContext, getters.contextClientId).then((database) => {
        commit('setLatest', database[0])
      })
    }
  },
}

export default { actions, mutations, state }
